// @ts-nocheck
import Layout from "../components/Layout"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import { Avatar, Breadcrumbs, Grid2 as Grid, Divider, Chip, Button, IconButton, Fab } from "@mui/material"
import Box from "@mui/material/Box"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useParams, useNavigate } from "react-router-dom"
import { InfoRounded, Edit, Info, Trash, Handshake } from "@mui/icons-material"
import DialogForm from "../components/DialogForm"
import { useSnackbarMessage } from "../hooks/snackbar"
import { DataField, DataFieldLabel, DataFieldLink, DataRow } from "../components/DataField"
import { SectionTitle } from "../components/SectionTitle"
import { PageTitle } from "../components/PageTitle"
import { useTranslation } from "react-i18next"
import FormatDate from "../components/FormatDate"
import RecordInfo from "../components/RecordInfo"
import DeleteBar from "../components/DeleteBar"
import DialogConfirm from "../components/DialogConfirm"
import {
  useDonatore,
  useDonatoreDelete,
  useDonatoreHistory,
  useDonatoreSetAllegati,
  useDonatoreUpdate,
} from "../hooks/donatori"
import { Donatore, WithAllegati } from "../types"
import DonatoreForm from "../components/forms/DonatoreForm"
import AllegatiForm from "../components/forms/AllegatiForm"
import AllegatiGrid from "../components/AllegatiGrid"
import { useDesiredHeight } from "../hooks/measuring"
import { joinNomeCognome } from "../utils/text"
import useUserCanWriteAndDelete from "../hooks/permissions"
import { useIsMobile } from "../hooks/mobile"
import { useAuth } from "../auth"
import { useEffect } from "react"

export default function DonatoreDettaglio() {
  const { id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: donatore, refetch } = useDonatore(parseInt(id as string))
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const isMobile = useIsMobile()

  const [updateModalState, updateModalActions] = useModalTrigger()
  const [deleteModalState, deleteModalActions] = useModalTrigger()
  const [updateModalStateAllegati, updateModalActionsAllegati] = useModalTrigger()

  const { mutateAsync: update } = useDonatoreUpdate()
  const { mutateAsync: remove } = useDonatoreDelete()
  const { mutateAsync: setAllegati } = useDonatoreSetAllegati(id)

  const showMessage = useSnackbarMessage()
  const navigate = useNavigate()

  const historyBag = useDonatoreHistory(id)
  const { ref, desiredHeight } = useDesiredHeight(24)
  const lang = i18n.language
  
  const { user } = useAuth()
  

  useEffect(() => {
    if (user?.ruolo === "consultazione") {
      navigate(`/${lang}/fondi`)
    }
  }, [user, lang, navigate])

  return (
    <Layout>
      <Stack sx={{ height: "100%", overflow: "hidden" }}>
        <PageTitle
          padding
          border
          title={donatore?.nome + " " + donatore?.cognome}
          breadcrumbs={[
            {
              label: t("general.donatori"),
              iconType: Handshake,
              to: `/${lang}/donatori`,
            },
            {
              label: joinNomeCognome(donatore?.cognome, donatore?.nome),
            },
          ]}
        />

        <Grid
          container
          spacing={2}
          sx={{
            overflow: "auto",
            height: "100%",
            p: 3,
            pt: 2,
          }}
        >
          <Grid
            size={{
              xs: 12,
              xl: 12,
            }}
          >
            <Stack
              flexGrow={1}
              sx={{
                height: "fit-content",
                position: "relative",
                bgcolor: "white",
                boxShadow: 1,
              }}
            >
              <SectionTitle
                first
                title={t("donatore.anagrafica")}
                onEdit={() => {
                  updateModalActions.open()
                }}
              />
              <Box px={3} pb={2}>
                <DataRow>
                  <DataField
                    label={t("donatore.cognome_nome")}
                    value={joinNomeCognome(donatore?.nome, donatore?.cognome)}
                    size={4}
                  />
                  <DataField
                    label={t("donatore.data_nascita")}
                    value={<FormatDate>{donatore?.data_nascita}</FormatDate>}
                    size={4}
                  />
                  <DataField label={t("donatore.luogo_nascita")} value={donatore?.luogo_nascita_data?.nome} size={4} />
                </DataRow>

                <DataRow>
                  <DataField label={t("donatore.indirizzo")} value={donatore?.indirizzo} size={4} />
                  <DataField label={t("donatore.telefono")} value={donatore?.telefono} size={4} />
                  <DataField label={t("donatore.cellulare")} value={donatore?.mobile} size={4} />
                </DataRow>

                <DataRow>
                  <DataField label={t("donatore.cf")} value={donatore?.cf} size={4} />
                  <DataField label={t("donatore.email")} value={donatore?.email} size={4} />
                  <DataField label={t("donatore.doc_id")} value={donatore?.doc_id} size={4} />
                </DataRow>

                <DataRow>
                  <DataField label={t("donatore.note")} value={donatore?.note} size={8} />
                </DataRow>

                <DataRow last>
                  <Grid size={12}>
                    <DataFieldLabel label={t("general.fondi")} />
                    <div>
                      {donatore?.fondi_data?.map((fondo, index) => (
                        <span key={fondo.id}>
                          <DataFieldLink
                            display="inline-flex"
                            link={`/fondi/${fondo.id}`}
                            key={fondo.id}
                            value={fondo.segnatura}
                          />
                          {index < (donatore.fondi_data || []).length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                  </Grid>
                </DataRow>
              </Box>

              <SectionTitle
                first
                title={t("sections.allegati")}
                onEdit={() => {
                  updateModalActionsAllegati.open()
                }}
              />
              <Box px={3} py={2}>
                <AllegatiGrid allegati_data={donatore?.allegati_data} />
              </Box>
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 12,
              xl: 12,
            }}
          >
            <Stack
              ref={ref}
              sx={{
                bgcolor: "grey.200",
                borderRadius: 1,
                boxShadow: 1,
              }}
            >
              <SectionTitle bgcolor="grey.700" info />
              <Stack sx={{ p: 2 }} flexGrow={1}>
                <RecordInfo
                  first_update={donatore?.first_update}
                  last_update={donatore?.last_update}
                  historyBag={historyBag}
                />
              </Stack>
              {userCanWriteAndDelete && !isMobile && donatore?.can_delete && (
                <DeleteBar title={t("donatore.cta_elimina")} onDelete={() => deleteModalActions.open(donatore)} />
              )}
            </Stack>
          </Grid>
        </Grid>
      </Stack>

      <DialogForm<Donatore>
        open={updateModalState.isOpen}
        handleClose={updateModalActions.close}
        FormComponent={DonatoreForm}
        title={t("donatore.cta_modifica")}
        save={(values) => {
          return update(values).then(() => {
            updateModalActions.close()
            refetch()
            showMessage(t("donatore.esito_modifica_ok"))
          })
        }}
        item={donatore}
        hasCancel
      />

      <DialogForm<WithAllegati>
        open={updateModalStateAllegati.isOpen}
        handleClose={updateModalActionsAllegati.close}
        FormComponent={AllegatiForm}
        title={t("general.cta_modifica_allegati")}
        save={(values) => {
          const allegatiData = values.allegati_data.map((a) => {
            return {
              id: a.id,
              note: a.note,
              attachment: typeof a.attachment === "string" ? undefined : a.attachment,
            }
          })
          return setAllegati({ allegati: allegatiData }).then(() => {
            updateModalActionsAllegati.close()
            refetch()
            showMessage(t("donatore.esito_modifica_ok"))
          })
        }}
        item={{ allegati_data: donatore?.allegati_data }}
        hasCancel
      />

      <DialogConfirm
        open={deleteModalState.isOpen}
        handleClose={deleteModalActions.close}
        title={t("donatore.cta_elimina")}
        subtitle={
          <span>
            {t("donatore.cta_subtitle_elimina")} <b>"{deleteModalState.value?.nome}"</b>&nbsp;?
          </span>
        }
        textConfirm={t("general.elimina")}
        onConfirm={() => {
          return remove(deleteModalState.value.id).then(() => {
            deleteModalActions.close()
            showMessage(t("donatore.esito_elimina_ok"))
            navigate(`/${i18n.language}/donatori`)
          }).catch(() => {
            deleteModalActions.close()
            showMessage(t("general.esito_elimina_errore"), "error")
          })
        }}
      />
    </Layout>
  )
}
